<p-messages [(value)]="msgs"></p-messages>
<div class="p-grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{appConfig.ux.loadingMsg}}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar> 
        </div>
    </div>
    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <div class="card p-p-4">
            <form #facturaEditorForm="ngForm" 
                  (ngSubmit)="confirmarFacturar($event);"
                  [ngClass]="{'disabledForm': factura && factura.internalStatus && (factura.internalStatus == 'REJECTED' || factura.internalStatus == 'CANCELLED' || factura.internalStatus == 'INVALID')}"><!-- facturaEditorForm.reset();-->
                <div class="p-fluid p-formgrid grid">
                    <div class="p-field col-12">
                        <h3 class="uppercase">{{ appConfig.app.name }}  {{ factura.secuencial ?  '|' : '' }} {{ factura.secuencial ?  factura.secuencial : '' }}</h3>
                    </div>
                    <div class="p-field col-12"
                         *ngIf="factura && factura.claveAcceso">
                        <i class="pi pi-key"></i><span>{{ factura.claveAcceso }}</span>
                    </div>
                    <div class="p-p-field col-12">
                        <p-button styleClass="p-button-raised p-button-text p-button-success"
                                  (click)="activePopupSubjectCustomers($event)"
                                  [disabled]="(factura && factura.secuencial)">
                            <div class="p-field col-12 mb-0">
                                <div class="flex align-items-center justify-content-between">
                                    {{ subjectCustomer.id ? subjectCustomer.customerFullName : 'Cliente...'}}
                                    / {{ subjectCustomer.id ? subjectCustomer.customerCode : 'CI/RUC...'}}
                                    <i class="pi pi-user-edit required-icon"></i>
                                </div>
                            </div>
                        </p-button>
                    </div>
                    <div class="p-field col-12" *ngIf="subjectCustomer && subjectCustomer.id">
                        <label for="direccion">Dirección</label>
                        <textarea #direccion="ngModel" id="direccion" name="direccion" type="text"
                                  [(ngModel)]="factura.direccion" 
                                  [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                                  [rows]="2"
                                  [maxlength]="appConfig.app.text.max_length"
                                  placeholder="Dirección del cliente"
                                  [disabled]="false"
                                  [required]='true'
                                  pInputTextarea></textarea>
                        <p-message severity="error" [text]="appConfig['validationMsgs']['safeMultilineTextPattern']" 
                                   *ngIf="facturaEditorForm.controls['direccion'] 
                                   && !facturaEditorForm.controls['direccion'].valid 
                                   && (facturaEditorForm.controls['direccion'].dirty 
                                   || facturaEditorForm.controls['direccion'].touched)">
                        </p-message>
                    </div>
                    <div class="p-field col-12" *ngIf="(!factura || (subjectCustomer && subjectCustomer.id)) && factura.internalStatus != 'CREATED' && this.factura.internalStatus != 'POSTED'">
                        <label for="destinatarios">Notificar a: </label><span class="required-asterisk mr-2">*</span>
                        <mat-form-field id="destinatarios" class="chip-list" appearance="fill">
                            <mat-label>(Presione enter, espacio, escape o coma, para separar destinatarios)</mat-label>
                            <mat-chip-list #chipList aria-label="Selección de destinatarios">
                                <mat-chip
                                    *ngFor="let destinatario of destinatarios"
                                    (removed)="removerDestinatario(destinatario)">
                                    {{destinatario}}
                                    <button matChipRemove>
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip>
                                <input
                                    placeholder="Agregar..."
                                    #destinatarioInput
                                    [formControl]="destinatarioCtrl"
                                    [matAutocomplete]="auto"
                                    [matChipInputFor]="chipList"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    (matChipInputTokenEnd)="agregarDestinatario($event)"
                                    [matChipInputAddOnBlur]="false"
                                    (blur)="agregarDestinatarioBlur($event)">
                            </mat-chip-list>
                            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedDestinatario($event)">
                                <mat-option *ngFor="let destinatario of filtered | async" [value]="destinatario">
                                    {{destinatario}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    <div class="p-field col-12"
                         *ngIf="isUnitDetail">
                        <p-button styleClass="p-button-raised p-button-text p-button-success"
                                  (click)="activePopupProducts($event)"
                                  [disabled]="factura && factura.secuencial">
                            <ng-template pTemplate="content">
                                <div class="p-field col-12 mb-0">
                                    <div class="flex align-items-center justify-content-between">
                                        {{ product.id ? product.name : 'Servicio/Producto...' }}
                                        <i class="pi pi-plus required-icon"></i>
                                    </div>
                                </div>  
                            </ng-template>
                        </p-button>
                    </div>
                    
                    <div class="p-field col-12"
                         *ngIf="isUnitDetail">
                        <p-inputNumber #subtotal="ngModel" id="subtotal" name="subtotal"
                                       [(ngModel)]="factura.price" 
                                       (onBlur)="calcularConSubtotalPersonalizado($event)"
                                       placeholder="0.00"
                                       mode="currency" currency="USD" locale="en-US"
                                       [min]="0" [minFractionDigits]="2" [maxFractionDigits]="2"
                                       prefix="el monto de "
                                       [disabled]="factura && factura.secuencial"
                                       required>
                        </p-inputNumber>
                        <p-message severity="error" [text]="appConfig['validationMsgs']['numberPattern']" 
                                   *ngIf="facturaEditorForm.controls['subtotal']
                                   && !facturaEditorForm.controls['subtotal'].valid 
                                   && (facturaEditorForm.controls['subtotal'].dirty 
                                   || facturaEditorForm.controls['subtotal'].touched)">
                        </p-message>
                    </div>
                    <div class="p-field col-12"
                         *ngIf="isUnitDetail">
                        <p-inputNumber #descuento="ngModel" id="descuento" name="descuento"
                                       [(ngModel)]="factura.descuento" 
                                       (onBlur)="calcularConSubtotalPersonalizado($event)"
                                       placeholder="0.00"
                                       mode="currency" currency="USD" locale="en-US"
                                       [min]="0" [minFractionDigits]="2" [maxFractionDigits]="2"
                                       prefix="descuento "
                                       [disabled]="factura && factura.secuencial"
                                       required>
                        </p-inputNumber>
                        <p-message severity="error" [text]="appConfig['validationMsgs']['numberPattern']" 
                                   *ngIf="facturaEditorForm.controls['descuento']
                                   && !facturaEditorForm.controls['descuento'].valid 
                                   && (facturaEditorForm.controls['descuento'].dirty 
                                   || facturaEditorForm.controls['descuento'].touched)">
                        </p-message>
                    </div>
                    <div class="p-field col-12" 
                         *ngIf="isUnitDetail && details.length > 0">
                        <textarea #description="ngModel" id="description" name="description" type="text"
                                  [(ngModel)]="factura.description" 
                                  [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                                  [rows]="3"
                                  placeholder="Detallar..."
                                  [disabled]="factura && factura.secuencial"
                                  pInputTextarea></textarea>
                        <p-message severity="error" [text]="appConfig['validationMsgs']['safeMultilineTextPattern']" 
                                   *ngIf="facturaEditorForm.controls['description'] 
                                   && !facturaEditorForm.controls['description'].valid 
                                   && (facturaEditorForm.controls['description'].dirty 
                                   || facturaEditorForm.controls['description'].touched)">
                        </p-message>
                    </div>
                    <div class="p-field col-12 mb-0">
                        <p-button *ngIf="!isUnitDetail"
                                  styleClass="p-button-outlined p-button-secondary"
                                  (click)="activePopupProducts($event)"
                                  [disabled]="factura && factura.secuencial">
                            <ng-template pTemplate="content">
                                <div class="p-field col-12 mb-0">
                                    <div class="flex align-items-center justify-content-between">
                                        {{'Agregar Servicio/Producto...'}}
                                        <i class="pi pi-plus required-icon"></i>
                                    </div>
                                </div>  
                            </ng-template>
                        </p-button>
                        <div id="invoice-content">
                            <div class="invoice p-0">
                                <div *ngIf="!isUnitDetail" 
                                     class="invoice-items p-0 m-1">
                                    <p-message [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
                                        severity="info"
                                        text="Clic sobre cantidad o precio de cada detalle para edición rápida"
                                        [closable]="true">
                                    </p-message>
                                    <p-table [value]="details" dataKey="productId"
                                             (onEditComplete)="onEditComplete($event)">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th> {{'Descripción'}} </th>
                                                <th> {{'Cantidad'}} </th>
                                                <th> {{'Precio Unitario'}} </th>
                                                <th> {{'Descuento'}} </th>
                                                <th> {{'Valor Total'}} </th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-rowData>
                                            <tr>    
                                                <td>{{rowData['product']['name']}} <p-badge [value]="'IVA ' + rowData['product']['taxFactor']"></p-badge></td>
                                                <td pEditableColumn>
                                                    <p-cellEditor>
                                                        <ng-template pTemplate="input">
                                                            <p-inputNumber 
                                                                [(ngModel)]="rowData.amount"
                                                                [showButtons]="true" 
                                                                inputId="stacked" 
                                                                mode="decimal" locale="en-US"
                                                                [minFractionDigits]="3"
                                                                placeholder="Ingrese la cantidad de producto"
                                                                [ngModelOptions]="{standalone: true}">
                                                            </p-inputNumber>
                                                        </ng-template>
                                                        <ng-template pTemplate="output">
                                                            {{rowData['amount']}}
                                                        </ng-template>
                                                    </p-cellEditor>
                                                </td>
                                                <td pEditableColumn>
                                                    <p-cellEditor>
                                                        <ng-template pTemplate="input">
                                                            <p-inputNumber 
                                                                [(ngModel)]="rowData.price"
                                                                [showButtons]="true" 
                                                                inputId="stacked" 
                                                                mode="decimal" locale="en-US"
                                                                [minFractionDigits]="3"
                                                                placeholder="Indique el precio del producto"
                                                                [ngModelOptions]="{standalone: true}">
                                                            </p-inputNumber>
                                                        </ng-template>
                                                        <ng-template pTemplate="output">
                                                            {{rowData['price']}}
                                                        </ng-template>
                                                    </p-cellEditor>
                                                </td>
                                                <td pEditableColumn>
                                                    <p-cellEditor>
                                                        <ng-template pTemplate="input">
                                                            <p-inputNumber 
                                                                [(ngModel)]="rowData.discount"
                                                                [showButtons]="true" 
                                                                inputId="stacked" 
                                                                mode="decimal" locale="en-US"
                                                                [minFractionDigits]="3"
                                                                placeholder="Indique el descuento otorgado en este producto"
                                                                [ngModelOptions]="{standalone: true}">
                                                            </p-inputNumber>
                                                        </ng-template>
                                                        <ng-template pTemplate="output">
                                                            {{rowData['discount']}}
                                                        </ng-template>
                                                    </p-cellEditor>
                                                </td>
                                                <td>$ {{(rowData['price'] && rowData['amount']) ? ( ( rowData['amount'] * ( rowData['price'] ) - rowData['discount']) ).toFixed(3) : 0.000}}</td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                                <div class="invoice-summary p-0">
                                    <div class="invoice-notes">
                                        <div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="invoice-details">
                                            <div class="invoice-label">Sub. IVA 0%</div>
                                            <div class="invoice-value">$ {{ factura.subTotalIva0 ? factura.subTotalIva0.toFixed(2) : '0.00' }}</div>
                                            <div class="invoice-label">Sub. IVA {{ appConfig.app.iva.etiqueta }}</div>
                                            <div class="invoice-value">$ {{ factura.subTotalIva12 ? factura.subTotalIva12.toFixed(2) : '0.00' }}</div>
                                            <div class="invoice-label">SUBTOTAL</div>
                                            <div class="invoice-value">$ {{ factura.subTotal ? factura.subTotal.toFixed(2) : '0.00' }}</div>
                                            <div class="invoice-label">IVA {{ appConfig.app.iva.etiqueta }}</div>
                                            <div class="invoice-value">$ {{ factura.iva12Total ? factura.iva12Total.toFixed(2) : '0.00' }}</div>
                                            <div class="invoice-label">VALOR TOTAL</div>
                                            <div class="invoice-value">$ {{ factura.importeTotal ? factura.importeTotal.toFixed(2) : '0.00' }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field col-8">
                        <label for="paymentMethod"><strong>Forma de pago</strong></label><span class="required-asterisk">*</span>
                        <p-dropdown
                            #tipo="ngModel"
                            id="paymentMethod"
                            name="paymentMethod"
                            [options]="paymentMethods"
                            [(ngModel)]="selectedPaymentMethod"
                            optionLabel="description"
                            [filter]="true"
                            filterBy="description"
                            [showClear]="true">
                            <ng-template pTemplate="selectedItem">
                                <div class="country-item country-item-value" *ngIf="selectedPaymentMethod">
                                    <!-- <div>{{ selectedCuentaBancaria?.label }}</div> -->
                                    <div>{{ selectedPaymentMethod.description ?  selectedPaymentMethod.description : 'Selecione una forma de pago...'}}</div>
                                </div>
                            </ng-template>
                            <ng-template let-paymentMethod pTemplate="item">
                                <div class="country-item">
                                    <div>{{ paymentMethod?.description }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                    <div class="field col-4">
                        <label for="plazo">Plazo (días)</label>
                        <p-inputNumber #subtotal="ngModel" id="plazo" name="plazo"
                                       [(ngModel)]="factura.plazo" 
                                       placeholder="0"
                                       [min]="0" [minFractionDigits]="0" [maxFractionDigits]="0"
                                       [disabled]="factura && factura.secuencial"
                                       required>
                        </p-inputNumber>
                        <p-message severity="error" [text]="appConfig['validationMsgs']['numberPattern']" 
                                   *ngIf="facturaEditorForm.controls['plazo']
                                   && !facturaEditorForm.controls['plazo'].valid 
                                   && (facturaEditorForm.controls['plazo'].dirty 
                                   || facturaEditorForm.controls['plazo'].touched)">
                        </p-message>
                    </div>
                    <div class="p-field col-12" *ngIf="factura.internalStatus != 'CREATED' && this.factura.internalStatus != 'POSTED'">
                        <app-establecimientos titulo="Local Comercial" 
                                              [puntoEmisionSeleccionado]="emissionPointSelected"
                                              [establecimientos]="establishments"
                                              [mostrarSecuencias]="true"
                                              (onChange)="asignarPuntoEmision($event)"
                                              [requerido]="true"></app-establecimientos>
                    </div>
                    <div class="p-field col-12" *ngIf="camposAdicionales && camposAdicionales.length > 0 && factura.internalStatus != 'CREATED' && this.factura.internalStatus != 'POSTED'">
                        <label for="camposAdicionales"><strong>Información adicional en factura</strong></label><span class="required-asterisk">*</span>
                        <div *ngFor="let field of camposAdicionales">
                            <label *ngIf="field.type!= 'hidden'">{{field.label}}:</label>
                            <div [ngSwitch]="field.type">
                                <input *ngSwitchCase="'date'" [name]="field.name"
                                       type="date" pInputText class="form-control" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                                       [disabled]="field.disabled">
                                <input *ngSwitchCase="'number'" [name]="field.name"
                                       type="number" pInputText class="form-control" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                                       [disabled]="field.disabled">
                                <input *ngSwitchCase="'hidden'" [name]="field.name"
                                       type="hidden" class="form-control" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                                       [disabled]="field.disabled">
                                <input *ngSwitchDefault [name]="field.name" 
                                       type="text" pInputText class="form-control" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" maxlength="256"
                                       [disabled]="field.disabled">
                                <select *ngSwitchCase="'select'"  [name]="field.name" 
                                        class="form-control" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                                        [disabled]="field.disabled">
                                    <option *ngFor="let opt of field.options" [value]="opt.value">{{opt.label}}
                                    </option>
                                </select>
                                <p-message severity="warn" [text]="field.ayuda" 
                                   *ngIf="field.ayuda">
                                </p-message>
                            </div>
                        </div>
                    </div>
                </div>
                <p-footer>
                    <div class="flex align-items-center justify-content-end">
                        <button pButton pRipple
                                type="button" 
                                label="{{appConfig.ux.actions.cancel}}"
                                icon="pi pi-times" class="p-button-secondary"
                                (click)="fazilService.irAInicio()">
                        </button>
                        <button  pButton pRipple
                                 type="submit" 
                                 label="{{ (factura.internalStatus == 'CREATED' || this.factura.internalStatus == 'POSTED') ? 'Autorizar' : appConfig.ux.actions.invoicer}}"
                                 icon="pi pi-send" class="ml-1"
                                 [disabled]="(!facturaEditorForm.valid
                                 || !exitenProductosSeleccionados 
                                 || (!subjectCustomer || !subjectCustomer.customerId)
                                 || (!factura.importeTotal || factura.importeTotal <= 0)
                                 || (!establishment || !emissionPointSelected.id)
                                 || (!emissionPointSelected || !emissionPointSelected.id)
                                 || !camposAdicionalesValidos()
                                 || !destinatarios)">
                        </button>
                    </div>
                </p-footer>
            </form>
        </div>
    </div>
</div>
<p-messages [(value)]="msgs"></p-messages>
<!-- Buscador de contactos -->
<app-contacto-buscador
    [currentUser] ="currentUser"
    [mostrarBuscador] = "mostrarPopupSubjectCustomers"
    [estaCargandoDatos] = "false"
    (contactoSeleccionado) = "handleContactoSeleccionado($event);"
    ></app-contacto-buscador>

<!-- Buscador de productos -->

<app-producto-buscador
    [currentUser] ="currentUser"
    [mostrarBuscador] = "mostrarPopupProducts"
    [estaCargandoDatos] = "false"
    [cargarTodos] = "true"
    (productoSeleccionado) = "handleProductoSeleccionado($event);"
    (productoDeseleccionado) = "handleProductoDeseleccionado($event);"
    ></app-producto-buscador>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd 
                 header="{{appConfig.ux.confirmMsg}}" 
                 icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button pButton pRipple
                type="button" 
                label="{{appConfig.ux.confirmFalse}}"
                icon="pi pi-times" class="p-button-secondary"
                (click)="cd.reject()">
        </button>
        <button pButton pRipple
                type="button" 
                label="{{appConfig.ux.confirmTrue}}"
                icon="pi pi-check" class="ml-1"
                (click)="cd.accept()">
        </button>
    </ng-template>
</p-confirmDialog>
<!--Ventana de espera de procesamiento-->
<p-dialog [(visible)]="procesando" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '90vw', '640px': '100vw' }"
          [style]="{ width: '90vw' }"
          (onHide)="procesando=false;">
    <ng-template pTemplate="header">
        <h4>{{appConfig.ux.loadingMsg}}</h4>
        <p>Si ve esta pantalla mucho tiempo, cierrela. Vaya a la carpeta <strong>Por enviar</strong> ó <strong>Enviadas sin autorizar</strong> y presione el botón <strong>Pedir autorización</strong></p>
    </ng-template>
    <ng-template pTemplate="content">
        <p-progressBar mode="indeterminate"></p-progressBar> 
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="uppercase">{{appConfig.app.name}}</span>
    </ng-template>
</p-dialog>
<!--Ventana de resultData-->
<p-dialog [(visible)]="mostrarResultData" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '25vw', '640px': '35vw' }" 
          [style]="{ width: '25vw' }"
          (onHide)="mostrarResultData=false;">
    <ng-template pTemplate="header">
        <h4>{{resultData['header']}}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-messages severity="{{resultData['type']}}">
            <ng-template pTemplate>
                <div class="ml-2">{{resultData['body']}}</div>
            </ng-template>
        </p-messages>

        <p-panel header="Detalle de errores" [toggleable]="true" [collapsed]="true" *ngIf="resultData['subErrors'] && resultData['subErrors'].length > 0">
            <p-messages severity="info" *ngFor="let subError of resultData['subErrors']">
                <ng-template pTemplate>
                    <div class="ml-2">{{subError.field}} | {{subError.rejectedValue}} | {{subError.message}}</div>
                </ng-template>
            </p-messages>
        </p-panel>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex align-items-center justify-content-center">
            <button *ngFor="let item of resultDataButtons let i = index" 
                    pButton pRipple
                    type="button" 
                    [label]="item.text"
                    [icon]="item.icon"
                    [class]="item.cssClass"
                    (click)="ejecutarAccionResult($event, item.action, null)"
                    [disabled]="item.disabled">
            </button>
        </div>
    </ng-template>
</p-dialog>
<!--Ventana de espera de verificacion-->
<p-dialog [(visible)]="verificando"
          modal="modal" showEffect="fade"
          [breakpoints]="{ '960px': '15vw', '640px': '20vw' }" 
          [style]="{ width: '15vw' }"
          [closable]="false"
          (onHide)="verificando = false"
          class="text-center">
    <ng-template pTemplate="header">
    </ng-template>
    <ng-template pTemplate="content">
        <h6>{{verificandoData['body']}}</h6>
        <i class="pi pi-spin pi-spinner text-orange-400 text-8xl"></i>
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="p-text-uppercase">{{ appConfig.app.name }}</span>
    </ng-template>
</p-dialog>